var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#03a4fa",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0c-5.46875,0 -9.93359,4.42188 -10,9.875l-14.09375,7.0625c-1.65625,-1.21875 -3.69922,-1.9375 -5.90625,-1.9375c-5.51172,0 -10,4.48828 -10,10c0,5.51172 4.48828,10 10,10c2.20703,0 4.25,-0.71875 5.90625,-1.9375l14.09375,7.0625c0.06641,5.45313 4.53125,9.875 10,9.875c5.51172,0 10,-4.48828 10,-10c0,-5.51172 -4.48828,-10 -10,-10c-2.125,0 -4.09766,0.67578 -5.71875,1.8125l-13.65625,-6.8125l13.65625,-6.8125c1.62109,1.13672 3.59375,1.8125 5.71875,1.8125c5.51172,0 10,-4.48828 10,-10c0,-5.51172 -4.48828,-10 -10,-10zM40,2c4.42969,0 8,3.57031 8,8c0,4.42969 -3.57031,8 -8,8c-1.63672,0 -3.14062,-0.50781 -4.40625,-1.34375c-0.125,-0.41797 -0.50391,-0.70703 -0.9375,-0.71875c-0.00391,-0.00391 -0.02734,0.00391 -0.03125,0c-1.39453,-1.26172 -2.33203,-3.02734 -2.5625,-5c0.21094,-0.35156 0.1875,-0.79687 -0.0625,-1.125c0.10156,-4.33984 3.63281,-7.8125 8,-7.8125zM30.21875,12c0.37109,1.80859 1.23047,3.4375 2.4375,4.75l-12.84375,6.4375c-0.33984,-1.82812 -1.15625,-3.47656 -2.34375,-4.8125zM10,17c1.85156,0 3.55469,0.60938 4.90625,1.65625c0.01172,0.00781 0.01953,0.02344 0.03125,0.03125c0.00781,0.01953 0.01953,0.04297 0.03125,0.0625c0.08594,0.10547 0.19141,0.1875 0.3125,0.25c0.00391,0.00391 0.02734,-0.00391 0.03125,0c1.49609,1.32813 2.48438,3.22266 2.65625,5.34375c-0.11328,0.27344 -0.10156,0.58203 0.03125,0.84375c-0.01953,0.08203 -0.03125,0.16406 -0.03125,0.25c-0.12109,2.21875 -1.12891,4.19141 -2.6875,5.5625c-0.09375,0.05859 -0.17969,0.13281 -0.25,0.21875c-1.375,1.11328 -3.11719,1.78125 -5.03125,1.78125c-4.42969,0 -8,-3.57031 -8,-8c0,-4.42969 3.57031,-8 8,-8zM19.8125,26.8125l12.84375,6.4375c-1.20703,1.3125 -2.06641,2.94141 -2.4375,4.75l-12.75,-6.375c1.1875,-1.33594 2.00391,-2.98437 2.34375,-4.8125zM40,32c4.42969,0 8,3.57031 8,8c0,4.42969 -3.57031,8 -8,8c-4.42969,0 -8,-3.57031 -8,-8c0,-2.40625 1.04688,-4.56641 2.71875,-6.03125c0.02344,-0.01953 0.04297,-0.03906 0.0625,-0.0625c0.00391,-0.00391 0.02734,0.00391 0.03125,0c0.16016,-0.06641 0.30078,-0.17578 0.40625,-0.3125c1.33594,-0.99609 2.98047,-1.59375 4.78125,-1.59375z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cca5ddbd46ab28c4dd680e144709750e.svg";
export { ForwardRef as ReactComponent };